var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.emailTemplate)?_c('span',[_vm._v(_vm._s(_vm._f("ififnot")(_vm.condition.mustBe))+" clicked mail '"+_vm._s(_vm.emailTemplate.name.substring(0, 35))+"'")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }